import { PRIVATE_TOP_PATH } from '@/routes/private';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 古いURL形式からのリダイレクト: /analyze/:themeCode/* → /themes
 */
export const LegacyThemeRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // 古いURLでアクセスした場合、テーマ選択ページにリダイレクト
    // クエリパラメータでリダイレクト元を明示
    navigate(`${PRIVATE_TOP_PATH}?from=legacy-url`, { replace: true });
  }, [navigate]);

  return null;
};
